module.exports = __webpack_public_path__ + "img/henkel-123-logo.b9a8ce9b.png";